import { BottomSheet, Button, Flex, Text } from 'components/InterUI/InterUI'
import { ListDescription } from 'components'
import useBoundState from 'store'

import * as S from './Repurchase.styles'

interface Props {
  handleCloseBottomSheet: () => void
  isPaying: boolean
}

export const HelpBottomSheet = ({ handleCloseBottomSheet, isPaying }: Props) => {
  const contentTitle = useBoundState((state) => state.contentTitle)

  const title = isPaying
    ? 'Diferença a pagar: como funciona?'
    : 'Diferença a receber: como funciona?'

  const description3 = isPaying
    ? 'Dessa forma, você paga apenas a diferença.'
    : 'Dessa forma, você recebe a diferença do saldo restante.'
  return (
    <BottomSheet onClose={handleCloseBottomSheet}>
      <Flex direction="column" gap="16px" data-testid="help-bottom-sheet">
        <Text variant="headline-h3" as="h3" semiBold>
          {title}
        </Text>
        <ListDescription iconLeft={<S.CircleNumber>1</S.CircleNumber>} margin="16px 0 0 0">
          Primeiro, depositamos na sua conta o seu valor de resgate;
        </ListDescription>
        <ListDescription iconLeft={<S.CircleNumber>2</S.CircleNumber>}>
          Depois, debitamos o valor total dos {contentTitle.value2Lowercase};
        </ListDescription>
        <ListDescription iconLeft={<S.CircleNumber>3</S.CircleNumber>} margin="0 0 16px 0">
          {description3}
        </ListDescription>
        <Button
          data-testid="pay-button"
          fullWidth
          disabled={false}
          onClick={handleCloseBottomSheet}
        >
          Entendi
        </Button>
      </Flex>
    </BottomSheet>
  )
}
